import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../utils/analytics";
import { resolveToolName } from "../../utils/analyticsToolMap";

/**
 * Emits a GA4 page_view on every React Router location change (SPA coverage).
 * Mount once inside BrowserRouter.
 */
const AnalyticsPageListener = () => {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    const tool = resolveToolName(location.pathname);
    trackPageView({
      path,
      title: document.title,
      tool,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsPageListener;
